const setCartArray = (cartArray) => {
	let result = 0;

	if (cartArray.length > 0) {
		for (var i = 0; i <= cartArray.length; i++) {
			if (cartArray[i]) {
				result = result + (Number(cartArray[i].quantity) === 0 ? 1 : Number(cartArray[i].quantity));
			}
		}
	}

	return {
		type: 'SET_CART_ARRAY',
		cartArray: cartArray,
		cartQuantity: result,
	};
};

const setListArray = (listArray) => {
	return {
		type: 'SET_LIST_ARRAY',
		listArray: listArray,
	};
};

const setCurrentPrebasketProduct = (currentPrebasketProduct) => {
	return {
		type: 'SET_CURRENT_PREBASKET_PRODUCT',
		currentPrebasketProduct: currentPrebasketProduct,
	};
};

const setPrebasketUpdated = (prebasketUpdated) => {
	return {
		type: 'SET_PRE_BASKET_UPDATED',
		prebasketUpdated: prebasketUpdated,
	};
};

const setCartQuantity = (cartQuantity) => {
	return {
		type: 'SET_CART_QUANTITY',
		cartQuantity: cartQuantity,
	};
};

export { setCartArray, setListArray, setCartQuantity, setCurrentPrebasketProduct, setPrebasketUpdated };
